export const lang = state => state.lang;

export const counts = state => state.counts;

export const loading = state => state.loading;

export const pageOptions = state => state.pageOptions;
